




















import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

@Component
export default class CropCodesComponent extends Vue {
    @State('allVarieties') private varietiesState: any;
    @Action('getAllVarieties') private getVarietiesAction: any;

    private headers = [
        {
            text: 'Code',
            value: 'cropCode',
            align: 'center',
        },
        {
            text: 'Name',
            value: 'name',
            align: 'center',
        },
    ];

    private created() {
        this.getVarietiesAction();
    }
}
